import { useContext } from "react";
import ProgressPerformanceContext from "../context/progressPerfomanceProvider";

const useProgressPerformanceTabs = () => {
  const { tabs, setTabs } = useContext(ProgressPerformanceContext);

  return {
    tabs,
    setTabs,
  };
};

export default useProgressPerformanceTabs;
